module.exports = __webpack_public_path__ + "img/647.ca595dde.jpg";